const initialState = {
  permissions: {
    toggleAll: false // Hiding this as toggling on/off is too destructive until we have undo per @steve
  }
};
export default (state = initialState) => state;
